/* eslint-disable indent */
import React, { useState, useEffect } from "react";
import { Radio } from "antd";
import { spaceBeforeCapital } from "../../utils";
import DynamicRateMatrixTable from "./DynamicRateMatrixTable";
import "./index.scss";
import serviceType from "../../assests/images/service.svg";
import parcelType from "../../assests/images/parcel.svg";
import travelMode from "../../assests/images/travel-mode.svg";

const DynamicRateCard = ({
  travelModeType,
  docType,
  shippingType,
  matrixData,
  onChangeMatrixData = () => {},
  deleteZone = () => {},
  addZone = () => {},
  defaultZones,
  actionEdit,
  customerId,
  rateCardType,
  rateCardError = [],
  defaultRateCardMatrix,
  showValueChangedPercentage,
  disableNewWeightSlabs = false,
  editHighValue,
  showHighLight = false,
  originalMatrixData = {},
  highlightedTypes = [],
  rateCardId = null,
}) => {
  const [selectedShippingType, setSelectedShippingType] = useState(
    shippingType?.[0]
  );
  const [selectedDocType, setSelectedDocType] = useState(docType?.[0]);
  const [selectedTravelModeType, setSelectedTravelModeType] = useState(
    travelModeType?.[0]
  );
  const [selectedMatrixData, setSelectedMatrixData] = useState([]);
  const [selectedOriginalMatrixData, setSelectedOriginalMatrixData] = useState(
    []
  );
  const [selectedOldMatrixData, setSelectedOldMatrixData] = useState([]);
  const [selectedDefaultRateCardMatrix, setSelectedDefaultRateCardMatrix] =
    useState({});

  useEffect(() => {
    if (rateCardError?.length > 0) {
      setSelectedDocType(rateCardError[0]?.doc);
      setSelectedTravelModeType(rateCardError[0]?.travelMode);
      setSelectedShippingType(rateCardError[0]?.shipping);
    }
  }, [rateCardError]);
  useEffect(() => {
    if (docType?.length) {
      setSelectedDocType(docType[0]);
    }
    if (travelModeType?.length) {
      setSelectedTravelModeType(travelModeType[0]);
    }
    if (shippingType?.length) {
      setSelectedShippingType(shippingType[0]);
    }
  }, [docType, travelModeType, shippingType]);

  useEffect(() => {
    setSelectedMatrixData(
      matrixData?.[selectedDocType]?.[selectedTravelModeType]?.[
        selectedShippingType
      ]
    );

    setSelectedOriginalMatrixData(
      JSON.parse(originalMatrixData)?.[selectedDocType]?.[
        selectedTravelModeType
      ]?.[selectedShippingType]
    );

    setSelectedOldMatrixData(
      matrixData?.[selectedDocType]?.[selectedTravelModeType]?.[
        `${selectedShippingType}_old`
      ]
    );
    setSelectedDefaultRateCardMatrix(
      defaultRateCardMatrix?.[selectedDocType]?.[selectedTravelModeType]?.[
        selectedShippingType
      ]
    );
  }, [
    selectedDocType,
    selectedTravelModeType,
    selectedShippingType,
    matrixData,
  ]);
  const getSelectedMatrixData = (value, type) => {
    switch (type) {
      case "shippingType":
        setSelectedShippingType(value?.target?.value);

        break;
      case "docType":
        setSelectedDocType(value?.target?.value);

        break;
      case "travelModeType":
        setSelectedTravelModeType(value?.target?.value);

        break;
    }

    // console.log(matrixData?);
  };

  return (
    <div className="mt-05 p-1">
      <div className="d-flex">
        <div className="rate-select-card shipping-type">
          <div className="rate-select-card-title mb-05">
            <img src={serviceType} alt="Service" className="mr-1" />
            Service Type
          </div>

          <Radio.Group
            onChange={(e) => getSelectedMatrixData(e, "shippingType")}
            value={selectedShippingType}
          >
            {shippingType?.map((item, index) => {
              if (!item?.split("_")?.includes("old")) {
                return (
                  <Radio.Button
                    value={item}
                    key={index}
                    style={{
                      background:
                        showHighLight && highlightedTypes?.includes(item)
                          ? "#ffe58f"
                          : "transparent",
                    }}
                  >
                    {spaceBeforeCapital(item)}
                  </Radio.Button>
                );
              }
              return null;
            })}
          </Radio.Group>
        </div>

        <div className="rate-select-card doc-type ml-2">
          <div className="rate-select-card-title mb-05">
            <img src={parcelType} alt="Parcel" className="mr-1" />
            Parcel Type
          </div>
          <Radio.Group
            onChange={(value) => getSelectedMatrixData(value, "docType")}
            value={selectedDocType}
          >
            {docType?.map((item, index) => (
              <Radio.Button
                value={item}
                key={index}
                style={{
                  background:
                    showHighLight && highlightedTypes?.includes(item)
                      ? "#ffe58f"
                      : "transparent",
                }}
              >
                {spaceBeforeCapital(item)}
              </Radio.Button>
            ))}
          </Radio.Group>
        </div>

        <div className="rate-select-card travel-mode-type ml-2">
          <div className="rate-select-card-title mb-05">
            <img src={travelMode} alt="Travel" className="mr-1" />
            Travel Mode
          </div>
          <Radio.Group
            onChange={(value) => getSelectedMatrixData(value, "travelModeType")}
            value={selectedTravelModeType}
          >
            {travelModeType?.map((item, index) => (
              <Radio.Button
                value={item}
                key={index}
                style={{
                  background:
                    showHighLight && highlightedTypes?.includes(item)
                      ? "#ffe58f"
                      : "transparent",
                }}
              >
                {spaceBeforeCapital(item)}
              </Radio.Button>
            ))}
          </Radio.Group>
        </div>
      </div>
      <DynamicRateMatrixTable
        actionEdit={actionEdit}
        customerId={customerId}
        rateCardType={rateCardType}
        defaultZones={defaultZones}
        selectedMatrixData={selectedMatrixData}
        selectedOriginalMatrixData={selectedOriginalMatrixData}
        selectedOldMatrixData={selectedOldMatrixData}
        onDeleteZone={(val) => deleteZone(val)}
        onAddZone={(
          values,
          actionType,
          editSelectedZone,
          addZoneId,
          actionCreate
        ) =>
          addZone(values, actionType, editSelectedZone, addZoneId, actionCreate)
        }
        onSelectedMatrixChange={(val) => {
          setSelectedMatrixData(val);
          onChangeMatrixData(
            val,
            selectedDocType,
            selectedTravelModeType,
            selectedShippingType
          );
        }}
        selectedDefaultRateCardMatrix={selectedDefaultRateCardMatrix}
        showValueChangedPercentage={showValueChangedPercentage}
        disableNewWeightSlabs={disableNewWeightSlabs}
        editHighValue={editHighValue}
        showHighLight={showHighLight}
        rateCardId={rateCardId}
      />
    </div>
  );
};

export default DynamicRateCard;
